import { Box, Stack, Text, xcss } from '@atlaskit/primitives';
import React, { type ReactNode } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../messages';

export type DefaultValueInputSlotProps = {
  ariaDescribedBy: string | undefined;
  ariaLabel: string;
  inputId: string;
  placeholder: string;
};

type DefaultValueInputProps = {
  children: (slotProps: DefaultValueInputSlotProps) => ReactNode;
  hasValue?: boolean;
  placeholder?: string;
  shouldForwardLabelClick?: boolean;
  testId?: string;
};

const inputWrapperStyles = xcss({
  width: '100%'
});

const DefaultValueInput = (props: DefaultValueInputProps) => {
  const { formatMessage } = useIntl();
  const inputId = 'default-value-input';
  const helperId = 'default-value-input-helper';
  const label = formatMessage(messages.defaultValueInputLabel);
  const helperText = formatMessage(messages.defaultValueInputHelper);
  const placeholder =
    props.placeholder ?? formatMessage(messages.defaultValueInputPlaceholder);
  const hasValue = props.hasValue ?? false;
  const ariaDescribedBy = hasValue ? helperId : undefined;

  const slotProps: DefaultValueInputSlotProps = {
    ariaDescribedBy,
    ariaLabel: label,
    inputId,
    placeholder
  };

  return (
    <Stack testId={props.testId} space="space.050">
      <label htmlFor={props.shouldForwardLabelClick === false ? undefined : inputId}>
        <Text size="small" weight="bold" color="color.text.subtle">
          {label}
        </Text>
      </label>
      <Box xcss={inputWrapperStyles}>{props.children(slotProps)}</Box>
      {hasValue && (
        <Text id={helperId} size="small" color="color.text.subtlest">
          {helperText}
        </Text>
      )}
    </Stack>
  );
};

export default DefaultValueInput;
